import { AlertTriangle, PackageCheck } from 'lucide-react';
import WidgetShell from '../WidgetShell';
import { useLowStock } from '@/hooks/dashboard/useEcomDashboard';

export default function LowStockWidget() {
  const { data: items, isLoading, error } = useLowStock();

  return (
    <WidgetShell
      title="Low Stock"
      icon={<AlertTriangle />}
      to="/admin/inventory?filter=low_stock"
      isLoading={isLoading}
      error={error}
      isEmpty={!!items && items.length === 0}
      emptyMessage="All stock levels are healthy"
      emptyIcon={<PackageCheck />}
      skeletonClassName="h-40"
    >
      {items && items.length > 0 && (
        <ul className="divide-y divide-line">
          {items.slice(0, 6).map((item) => (
            <li key={item.variant_id} className="flex items-center gap-3 py-2.5">
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-ink">{item.product_name}</p>
                <p className="truncate text-xs text-stone-500">
                  {item.variant_name ? `${item.variant_name} · ` : ''}
                  {item.sku}
                </p>
              </div>
              <span className="text-sm font-semibold text-red-600">{item.current_stock}</span>
              <span className="text-xs text-stone-400">/ {item.threshold}</span>
            </li>
          ))}
        </ul>
      )}
    </WidgetShell>
  );
}
